import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import Link from 'react-router/lib/Link';
import { t } from '../../../../modules/infra/i18n';

const Option = ({ textKey, view, url, currentView, className, onClick }) => {
  const btnClass = classnames('c-btn c-btn--outline c-btn--medium c-btn--active-branding', {
    'is-active': currentView === view,
  });

  return (
    <Link to={url} className={className} onClick={onClick}>
      <span className={btnClass}>{t(textKey)}</span>
    </Link>
  );
};

Option.propTypes = {
  textKey: PropTypes.string.isRequired,
  view: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  currentView: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Option;
